import { graphql } from '~publish/graphql'

import { AccessRestricted_Channel } from '../AccessRestricted'
import { LastSyncActions_Channel } from '../LastSyncActions'
import { CommentCard_Channel } from '../../Comments/CommentCard'
import { CommentsList_Channel } from '../../Comments/CommentsList'
import { CommunityPageTitle_Channel } from '../../CommunityPageTitle'
import { EngagementAvatar_Channel } from '../../components/EngagementAvatar'
import { EngagementReplyForm_Channel } from '../../components/EngagementReplyForm/fragments/engagementReplyFormChannel'
import { MentionCard_Channel } from '../../Mentions/MentionCard/MentionCard'
import { MentionsList_Channel } from '../../Mentions/MentionsList/MentionsList'

export const ChannelPageCommentsFragment = graphql(/* GraphQL */ `
  fragment ChannelPageCommentsFragment on Channel {
    allowedActions
    id
    avatar
    isDisconnected
    isLocked
    name
    displayName
    metadata {
      ... on LinkedInMetadata {
        __typename
        shouldShowLinkedinAnalyticsRefreshBanner
      }
    }
    locationData {
      location
    }
    serverUrl
    service
    timezone
    type
    scopes
  }
`)

export const GetChannelInfoForComments = graphql(
  /* GraphQL */ `
    query GetChannelInfoForComments($channelId: ChannelId!) {
      channel(input: { id: $channelId }) {
        ...ChannelPageCommentsFragment
        ...EngagementAvatar_Channel
        ...CommentsList_Channel
        ...CommunityPageTitle_Channel
        ...AccessRestricted_Channel
        ...LastSyncActions_Channel
        ...CommentCard_Channel
        ...MentionsList_Channel
        ...MentionCard_Channel
        ...EngagementReplyForm_Channel
        allowedActions
        id
        avatar
        isLocked
        isDisconnected
        name
        displayName
        locationData {
          location
        }
        serverUrl
        service
        timezone
        type
        apiVersion
        scopes
        comments {
          lastUpdatedAt
          lastCheckedAt
          nextUpdateAt
        }
      }
    }
  `,
  // gql.tada requires spread fragments to be passed explicitly so their
  // types are composed in.
  [
    ChannelPageCommentsFragment,
    EngagementAvatar_Channel,
    CommentsList_Channel,
    CommunityPageTitle_Channel,
    AccessRestricted_Channel,
    LastSyncActions_Channel,
    CommentCard_Channel,
    MentionsList_Channel,
    MentionCard_Channel,
    EngagementReplyForm_Channel,
  ],
)
